import qs from 'qs';
import { network } from 'services/network';

export const setSubProgramPreferencePartialCompletion = (params) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setSubProgramPreferencePartialCompletion${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
